import React, {Component} from "react";
import { Dropdown } from 'primereact/dropdown';
var service = require('../admin/service/getinfo.js');
const customStyles = service.customStyles;

class DropdownComponent extends Component {
    /**
     * Renders a searchable dropdown for selecting one option.
     * @param {Object} props - React component props.
     * @param {Array} props.options - Dropdown options.
     * @param {string} props.placeholder - Placeholder shown before selection.
     * @param {Function} props.handleChange - Callback invoked when selection changes.
     * @param {*} props.value - Current selected value.
     * @return {JSX.Element} PrimeReact dropdown element.
     */
    render() {
        const { options, placeholder, handleChange, value } = this.props;

        return (
            <Dropdown 
            options={options} style={customStyles}
            placeholder={placeholder}
            onChange={handleChange} value={value}
            filter
            filterBy="label"
            />
        )
    }
}

export default DropdownComponent;